import React from 'react'

export default function PrivacyPolicy() {
  return (
    <div>privacy_policy</div>
  )
}
